class PresetsQuery {
    constructor(filter) {
        this.filter = filter;
        this.results = undefined;
    }

    isEqual(other) {
        let x = eqvArrays(this.filter.instrumentTypes, other.filter.instrumentTypes) &&
            eqvArrays(this.filter.tags, other.filter.tags);

        return x;
    }

    getPaginatedResults(start, size=10) {
        if (this.results === undefined) {
            return [];
        }

        if (this.results.length > start + size) {
            return this.results.slice(start, start + size);
        }

        return this.results.slice(start);
    }
}

function eqvArrays(a, b) {
    for (let i in a) {
        if (b[i] !== a[i]) {
            return false;
        }
    }
    for (let i in b) {
        if (b[i] !== a[i]) {
            return false;
        }
    }
    return true;
}

export default PresetsQuery;
